module.exports = __webpack_public_path__ + "static/media/blur-bg.1573fca8.jpg";